import Service from "../../AuthService";

const damages = {
    getDamages(page) {
        return Service.get("/damages-cost?page="+page);
    },
    showDamages(id,page) {
        return Service.get("/damages-cost/" + id +'?page='+page);
    },
    updateDamages(id, data) {
        return Service.put("/damages-cost/" + id, data);
    },
    createDamages(data) {
        return Service.post("/damages-cost", data);
    },
    deleteDamages(id) {
        return Service.delete("/damages-cost/" + id);
    },
    searchDamages(page,data){
        return Service.post("/damages-cost-search?page=" +page , data);
    }

};
export default damages;
